export default {"src":"https://cdn.jetlend.ru/_next/static/media/download.ed9b9219.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};